<template>
  <div class="main">
    <div class="logo"></div>
  <div class="content">
    <div class="ipt-box font-size14">
      <mobile-input @btnEnable="btnEnable" @btnDisable="btnDisable" @hideImgCode="hideImgCode"
                    :inputType="CONF.inputType.mobile" :errData="errData"></mobile-input>
      <img-code v-show="imgCodeShow" :options="imgCodeData" @mobileCodeSendSuccess="mobileCodeSendSuccess"></img-code>
      <mobile-code :mobileCodeBtnState="mobileCodeBtnState" :sendMsg="sendMsg" :inputType="CONF.inputType.mobile" :codeErrData="codeErrData"
                   :sendMsgTimer="sendMsgTimer"
                   @mobileCodeBtnEnable="mobileCodeBtnEnable" @mobileCodeSuccess="mobileCodeSuccess"  @showImgCode="showImgCode()" ></mobile-code>
      <div class="font-size12 color-cue voice" v-show="sendOneMsg&&countryCodeIndex==0">
        <div v-show="sendVoiceMsgBtnState== CONF.mobileCodeState.enable">收不到短信，<span class="color-voice" @click="showImgCode(true)">获取语音验证码</span></div>
        <div v-show="sendVoiceMsgBtnState== CONF.mobileCodeState.disable">收不到短信，<span>获取语音验证码</span></div>
        <div v-show="sendVoiceMsgBtnState== CONF.mobileCodeState.timeout">{{voiceTimer}}s后可重新获取</div>
      </div>
      <div class="account-btn"  v-show="submitBtnState == CONF.submitBtnState.enable" @click="login()">登&nbsp;录</div>
      <div  class="account-btn disable" v-show="submitBtnState == CONF.submitBtnState.disable">登&nbsp;录</div>
    </div>
    <div class="bottom-cue color-cue font-size14">首次使用验证码登录直接注册新帐号</div>
    <other-way>
      <div class="option-account font-size14 color-link">
        <router-link :to="CONF.urlList.Login.path+search" >帐号密码登录></router-link>
      </div>
    </other-way>
  </div>
  </div>
</template>
<style>
  .content .voice{
    line-height: 30px;
  }
</style>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  import MobileInput from '../components/mobileInput'
  import OtherWay from '../components/otherWay'
  import MobileCode from '../components/mobileCode'
  import ImgCode from '../components/imgCode'
  export default {
    components: {MobileInput, OtherWay, MobileCode, ImgCode},
    data () {
      return {
        CONF: CONF,
        imgCodeShow: false,
        imgCodeData: {},
        mobile: '',
        countryCodeIndex: 0,
        verifyCode: '',
        mobileFormatSuccess: false,
        mobileCodeBtnState: CONF.mobileCodeState.disable,
        submitBtnState: CONF.submitBtnState.disable,
        errData: {},
        sendOneMsg: false,
        voiceTimer: 60,
        sendVoiceMsgBtnState: CONF.mobileCodeState.disable,
        timeOutInter: null,
        channel: '',
        search: window.location.search,
        codeErrData: {},
        sendMsg: false,
        sendMsgTimer: ''
      }
    },
    created () {
      this.channel = server.getChannelType(this.$route.query.callback)
      let url = CONF.APIList.sendMsg
      this.imgCodeData = {'imgSrc': CONF.APIList.loginImgCode, 'mobile': this.mobile, 'sendUrl': url, 'ncode': CONF.countryList[this.countryCodeIndex].code, 'isVoice': false, inputType: CONF.inputType.mobile}
    },
    methods: {
// 按钮可用
      btnEnable (mobile, countryCodeIndex) {
        this.mobile = mobile
        this.countryCodeIndex = countryCodeIndex
        if (this.mobileCodeBtnState === CONF.mobileCodeState.disable) {
          this.mobileCodeBtnState = CONF.mobileCodeState.enable
        }
        if (this.sendVoiceMsgBtnState === CONF.sendVoiceMsgBtnState.disable) {
          this.sendVoiceMsgBtnState = CONF.sendVoiceMsgBtnState.enable
        }
        this.submitBtnState = CONF.submitBtnState.enable
      },
// 按钮不可用
      btnDisable (mobile) {
        this.mobile = mobile
        if (this.mobileCodeBtnState === CONF.mobileCodeState.enable) {
          this.mobileCodeBtnState = CONF.mobileCodeState.disable
        }
        if (this.sendVoiceMsgBtnState === CONF.sendVoiceMsgBtnState.enable) {
          this.sendVoiceMsgBtnState = CONF.sendVoiceMsgBtnState.disable
        }
        this.submitBtnState = CONF.submitBtnState.disable
      },
// 显示图形验证码
      showImgCode (isVoice) {
        if (!this.checkMobile()) return
        this.imgCodeShow = true
        let url = CONF.APIList.sendMsg
        if (isVoice) {
          url = CONF.APIList.sendVoiceMsg
        }
        this.imgCodeData = {'imgSrc': CONF.APIList.loginImgCode, 'mobile': this.mobile, 'sendUrl': url, 'ncode': CONF.countryList[this.countryCodeIndex].code, 'isVoice': isVoice, inputType: CONF.inputType.mobile}
      },
// 隐藏图形验证码
      hideImgCode (countryCodeIndex) {
        if (countryCodeIndex !== undefined) {
          this.sendMsgTimer = new Date().getTime()
          this.countryCodeIndex = countryCodeIndex
        }
        this.imgCodeShow = false
      },
// 填写手机验证码
      mobileCodeSuccess (mobileCode) {
        this.verifyCode = mobileCode
      },
// 登陆
      login () {
        let that = this
        if (!this.checkMobile()) return
        if (this.verifyCode.length === 0) {
          that.codeErrData = {errMsgShow: true, errMsg: CONF.errorMsg.empty.mobileCode}
          return
        } else {
          if (!CONF.reg.mobileCode.test(this.verifyCode)) return
        }
        this.submitBtnState = CONF.submitBtnState.disable
        let data = {mobile: this.mobile, ncode: CONF.countryList[this.countryCodeIndex].code, verifyCode: this.verifyCode, channel: this.channel}
        if (this.$route.query.connectid) {
          data.connectid = this.$route.query.connectid
        }
        server.appServices(this, CONF.APIList.codeLogin, data).then(res => {
          if (res.status === CONF.errCode.success.code) {
            if (that.$route.query.callback) {
              window.location.href = that.$route.query.callback
            } else {
              window.location.href = 'http://m.ismartv.cn'
            }
          } else {
            this.submitBtnState = CONF.submitBtnState.enable
            if (res.status === CONF.errCode.code103.code) {
              that.codeErrData = {errMsgShow: true, errMsg: CONF.errCode['code' + res.status].msg}
            } else {
              that.errData = {errMsgShow: true, errMsg: CONF.errCode['code' + res.status].msg}
            }
          }
        })
      },
// 检查手机格式
      checkMobile () {
        if ((this.countryCodeIndex === 0 && CONF.reg.chinaPhone.test(this.mobile)) || (this.countryCodeIndex !== 0 && CONF.reg.otherPhone.test(this.mobile))) {
          return true
        } else {
          return false
        }
      },
// 倒计时开启
      mobileCodeSendSuccess (isVoice) {
        this.sendMsgTimer = new Date().getTime()
// 语音
        if (isVoice) {
          let that = this
          that.voiceTimer = 60
          that.sendVoiceMsgBtnState = CONF.sendVoiceMsgBtnState.timeout
          that.timeOutInter = setInterval(function () {
            if (that.voiceTimer === 1) {
              clearInterval(that.timeOutInter)
              that.mobileCodeBtnEnable(isVoice)
            }
            that.voiceTimer--
          }, 1000)
// 短信
        } else {
          this.sendMsg = true
          if (this.countryCodeIndex === 0) this.sendOneMsg = true
          this.sendVoiceMsgBtnState = CONF.sendVoiceMsgBtnState.enable
          this.mobileCodeBtnState = CONF.mobileCodeState.timeout
        }
        this.imgCodeShow = false
      },
// 倒计时完成
      mobileCodeBtnEnable (isVoice) {
        if (isVoice) {
          if (this.mobile.length > 0) {
            this.sendVoiceMsgBtnState = CONF.sendVoiceMsgBtnState.enable
          } else {
            this.sendVoiceMsgBtnState = CONF.sendVoiceMsgBtnState.disable
          }
        } else {
          if (this.mobile.length > 0) {
            this.mobileCodeBtnState = CONF.mobileCodeState.enable
          } else {
            this.mobileCodeBtnState = CONF.mobileCodeState.disable
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// logincode.vue?15166975